import {
  Button,
  Alert,
  AlertTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Stack,
  Box,
  Tooltip,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useState, useEffect } from "react";
import NetworkWifi3BarIcon from "@mui/icons-material/NetworkWifi3Bar";

export default function MarketingBudgetHeader({
  pageName,
  error,
  changeYear,
  selectedYear,
  changeHandler,
  handleSave,
  handleTotalSummary,
  onBtExport,
  handleBudgetSummary,
  handleMarketingBudget,
}) {
  const [isShow, setIsShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [years, setYears] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (error === "Network Error") {
      setOpen(true);
    }
  }, [error]);

  useEffect(() => {
    let currentYears = new Date().getFullYear() + 1;
    const allYears = [];
    for (let i = 0; i < 5; i++) {
      allYears.push({
        label: currentYears,
        value: currentYears,
      });
      currentYears -= 1;
    }
    setYears(allYears);
    changeYear(allYears[1]);
  }, []);

  return (
    <>
      <div
        className="sticky top-0 z-20 "
        style={{ backgroundColor: "#212529" }}
      >
        <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 w-full items-center justify-between py-12 px-24 md:px-32">
          <div className="text-24 md:text-32 font-extrabold tracking-tight">
            <h1>{pageName.toUpperCase()}</h1>
          </div>
          <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
            <Stack direction="row" spacing={1}>
              {changeYear && (
                <div>
                  <Select
                    name="year"
                    placeholder="Select Year"
                    value={selectedYear}
                    onChange={changeYear}
                    options={years}
                    styles={customStyles()}
                  />
                </div>
              )}
              {/* {handleSave && (
                <Button
                  onClick={handleSave}
                  variant="contained"
                  color="warning"
                  startIcon={<FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>}
                >
                  Save
                </Button>
              )} */}
              {handleTotalSummary && (
                <Button
                  onClick={handleTotalSummary}
                  variant="contained"
                  color="warning"
                >
                  Total Summary
                </Button>
              )}
              {handleBudgetSummary && (
                <Button
                  onClick={handleBudgetSummary}
                  variant="contained"
                  color="warning"
                >
                  Budget Summary
                </Button>
              )}
              {handleMarketingBudget && (
                <Button
                  onClick={handleMarketingBudget}
                  variant="contained"
                  color="warning"
                >
                  Marketing Budget
                </Button>
              )}
              {onBtExport && (
                <Tooltip title={"Export"}>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={onBtExport}
                  >
                    <FuseSvgIcon>heroicons-solid:save</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
            </Stack>
          </div>
        </div>
        {/* {isShow && <Search />} */}
        {error === "Network Error" ? (
          <>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent
                sx={{ width: "600px", height: "auto", alignItems: "center" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NetworkWifi3BarIcon
                    sx={{ height: "100px", width: "100px", color: "#ffc107" }}
                  />
                </Box>
                <DialogContentText id="alert-dialog-description" align="center">
                  Please try after some times. Server is in maintainance.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} autoFocus>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        ) : (
          <>
            {error && (
              <Alert severity="error" className="mb-16">
                <AlertTitle>Error</AlertTitle>
                {error}
              </Alert>
            )}
          </>
        )}
      </div>
      {/* <Box sx={{ 
        display: 'flex',
        '& button': { mx: 1 } 
        }}>
        
    </Box> */}
    </>
  );
}
